import Vue from 'vue'
import VueRouter from 'vue-router'
import inventory from '../views/inventory.vue'
import clients from '../views/clients.vue'
import sellScreen from '../views/sellScreen.vue'
import products from '../views/products.vue'
import sales from '../views/sales.vue'
import compras from '../views/compras.vue'
import beneficios from '../views/beneficios.vue'
import database from '../views/database.vue'
// eslint-disable-next-line no-unused-vars
import i18n from '@/i18n'

Vue.use(VueRouter)

  const routes = [
    {
      path:'/',
      redirect:`/products`
    },
  {
    path:'/:lang',
    component:{
      render(c){return c('router-view')}
    },
    redirect:`/:lang/products`,
    children:[
    {
      path: 'sellScreen',
      name: 'Vender productos',
      component: sellScreen
    },
    {
      path: 'beneficios',
      name: 'Beneficios',
      component: beneficios
    },
    {
      path: 'compras',
      name: 'Compras',
      component: compras
    },
    {
      path: 'clients',
      name: 'Clientes',
      component: clients
    },
    {
      path: 'inventory',
      name: 'Inventorio',
      component: inventory
    },
    {
      path: 'products',
      name: 'Productos',
      component: products
    },
    {
      path: 'sales',
      name: 'Ventas',
      component: sales
    },  
    {
      path: 'database',
      name: 'database',
      component: database
    }
  ]
  }
]

const router = new VueRouter({
  mode: process.env.IS_ELECTRON ? 'hash' : 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
